module.exports = __webpack_public_path__ + "img/okta-brands.f3e3a687.svg";